import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './scss/main.scss';
import { CartProvider } from './context/CartContext';

import { HomePage } from './pages/Home';
import { Partnerzy } from './pages/Partnerzy';
import { Kontakt } from './pages/Kontakt';
import { NotFound } from './pages/404';
import { PolitykaPrywatnosci } from './pages/PolitykaPrywatnosci';
import { FAQ } from './pages/FAQ';
import { RozkladJazdy } from './pages/RozkladJazdy';
import { OWydarzeniu } from './pages/OWydarzeniu';
import { PolitykaPlikowCookie } from './pages/PolitykaPlikowCookie';
import { Galeria } from './pages/Galeria';
import { Rejestracja } from './pages/Rejestracja';
import { Rejestracja3 } from './pages/Rejestracja3';
import { HardAdvStore } from './pages/HardAdvStore';
import { PotwierdzenieEmaila } from './pages/PotwierdzenieEmaila';


export function App() {
  const router = createBrowserRouter([
    { path: '/', element: <HomePage /> },
    { path: '/o-wydarzeniu', element: <OWydarzeniu /> },
    { path: '/galeria/*', element: <Galeria /> },
    { path: '/rozklad-jazdy', element: <RozkladJazdy /> },
    { path: '/partnerzy', element: <Partnerzy /> },
    { path: '/faq', element: <FAQ /> },
    { path: '/kontakt', element: <Kontakt /> },
    { path: '/polityka-prywatnosci', element: <PolitykaPrywatnosci /> },
    { path: '/polityka-plikow-cookie', element: <PolitykaPlikowCookie /> },
    { path: '/rejestracja', element: <Rejestracja /> },
    { path: '/rejestracja3', element: <Rejestracja3 /> },
    { path: '/hard-adv-store', element: <HardAdvStore /> },
    { path: '/potwierdz-email', element: <PotwierdzenieEmaila /> },
    { path: '*', element: <NotFound /> },
  ]);

  return (
    <CartProvider>
      <RouterProvider router={router} />
    </CartProvider>
  );
}

export default App;
